import { composeWithDevTools } from '@redux-devtools/extension'
import { legacy_createStore as createStore, applyMiddleware, combineReducers } from 'redux'
import { thunk } from 'redux-thunk'

import { reducer as datatableReducer } from './store.reducer'

const rootReducer = combineReducers({
	datatable: datatableReducer,
})

const stores: Record<string, ReturnType<typeof createStore>> = {}

export const getStore = (key: string) => stores[key]

export const makeStore = (key: string) => {
	if (stores[key]) {
		return
	}

	const enhancer =
		process.env.NODE_ENV === 'production' ? applyMiddleware(thunk) : composeWithDevTools(applyMiddleware(thunk))

	stores[key] = createStore(rootReducer, enhancer)
}
